import qs from 'qs'

import { trackKinds } from 'constants/twilio'
import { userTypes } from 'constants/user'
import {
    getParticipantSidByIdentity,
    getTeacherSid,
    getRoomSid,
    isTeacher,
} from 'helpers/twilio'
import { isDesktop } from 'utils/device'
import { logger } from 'utils/logger'

import axiosInstance from '../httpInstance/twilioAxios'

const prepareRules = breakoutPartners => {
    let breakoutPartnerRules = ''
    if (breakoutPartners?.length) {
        breakoutPartners.forEach(breakoutPartner => {
            breakoutPartnerRules +=
                ',{"type": "include", "publisher": "' +
                breakoutPartner +
                '", "kind": "audio"}'
        })
    }

    let rules = qs.stringify({
        Rules:
            '[{"type": "include", "kind": "video"}' +
            breakoutPartnerRules +
            ']',
    })

    return rules
}

export const subscribeToParticipants = (
    breakoutPartners,
    roomSid,
    participantSid
) => {
    let currentRules = axiosInstance(null, roomSid, participantSid)

    currentRules.then(function(response) {
        let rules
        let currentPartners = []
        let isDefaultRule = false
        if (response.data) rules = response.data.rules
        if (rules)
            for (let rule in rules) {
                if (rules[rule].type === 'include' && rules[rule].publisher) {
                    //Check if requested partners have already been included or not
                    currentPartners.push(rules[rule].publisher)
                } else if (
                    rules.length === 1 &&
                    rules[rule].type === 'include' &&
                    rules[rule].all === true
                ) {
                    //Check if default rule is repeated or not.
                    //Length will be 1 if it is
                    isDefaultRule = true
                }
            }

        //Get if partners currently included and partners in the request are same
        let partnersUnchanged =
            breakoutPartners.length === currentPartners.length &&
            breakoutPartners.every(element => currentPartners.includes(element))

        //No action needed if
        //my partners haven't changed from current subscription
        //If the base rule is being repeated
        //If the default rule is being repeated
        if (partnersUnchanged && !isDefaultRule) return

        rules = rules = prepareRules(breakoutPartners)

        return axiosInstance(rules, roomSid, participantSid)
            .then(response => {
                logger.info(
                    `Subscribed to selected audio. ${JSON.stringify(
                        response.data
                    )}`
                )
            })
            .catch(error => {
                logger.error(
                    `Failed to subscribe to selected audio. ${JSON.stringify(
                        error
                    )}`
                )
            })
    })
}

export const subscribeToMyPartners = (
    breakoutPartners,
    roomSid,
    participantSid
) => {
    let currentRules = axiosInstance(null, roomSid, participantSid)
    currentRules.then(function(response) {
        let rules
        let currentPartners = []
        let isDefaultRule = false
        if (response.data) rules = response.data.rules
        if (rules)
            for (let rule in rules) {
                if (rules[rule].type === 'include' && rules[rule].publisher) {
                    //Check if requested partners have already been included or not
                    currentPartners.push(rules[rule].publisher)
                } else if (
                    rules.length === 1 &&
                    rules[rule].type === 'include' &&
                    rules[rule].all === true
                ) {
                    //Check if default rule is repeated or not.
                    //Length will be 1 if it is
                    isDefaultRule = true
                }
            }

        //Get if partners currently included and partners in the request are same
        let partnersUnchanged =
            breakoutPartners.length === currentPartners.length &&
            breakoutPartners.every(element => currentPartners.includes(element))

        //No action needed if
        //my partners haven't changed from current subscription
        if (partnersUnchanged && !isDefaultRule) return

        rules = prepareRules(breakoutPartners)
        return axiosInstance(rules, roomSid, participantSid)
            .then(response => {
                logger.info(
                    `Subscribed to audio of group partners. ${JSON.stringify(
                        response.data
                    )}`
                )
            })
            .catch(error => {
                logger.error(
                    `Failed to subscribed to audio of group partners. ${JSON.stringify(
                        error
                    )}`
                )
            })
    })
}

export const subscribeToTeacher = (
    breakoutPartners,
    roomSid,
    participantSid
) => {
    let currentRules = axiosInstance(null, roomSid, participantSid)
    currentRules.then(function(response) {
        let rules
        let currentPartners = []
        let isDefaultRule = false
        if (response.data) rules = response.data.rules
        if (rules)
            for (let rule in rules) {
                if (rules[rule].type === 'include' && rules[rule].publisher) {
                    //Check if requested partners have already been included or not
                    currentPartners.push(rules[rule].publisher)
                } else if (
                    rules.length === 1 &&
                    rules[rule].type === 'include' &&
                    rules[rule].all === true
                ) {
                    //Check if default rule is repeated or not.
                    //Length will be 1 if it is
                    isDefaultRule = true
                }
            }

        //Get if partners currently included and partners in the request are same
        let partnersUnchanged =
            breakoutPartners.length === currentPartners.length &&
            breakoutPartners.every(element => currentPartners.includes(element))

        //No action needed if
        //my partners haven't changed from current subscription
        //If the base rule is being repeated
        //If the default rule is being repeated
        if (partnersUnchanged && !isDefaultRule) return

        rules = rules = prepareRules(breakoutPartners)

        return axiosInstance(rules, roomSid, participantSid)
            .then(response => {
                logger.infos(
                    `Subscribed to audio of teacher along with group partners. ${JSON.stringify(
                        response.data
                    )}`
                )
            })
            .catch(error => {
                logger.error(
                    `Failed to subscribe to audio of teacher along with group partners. ${JSON.stringify(
                        error
                    )}`
                )
            })
    })
}

export const subscribeToStudents = (
    breakoutPartners,
    roomSid,
    participantSid
) => {
    let currentRules = axiosInstance(null, roomSid, participantSid)
    currentRules.then(function(response) {
        let rules
        let currentPartners = []
        let isDefaultRule = false
        if (response.data) rules = response.data.rules
        if (rules)
            for (let rule in rules) {
                if (rules[rule].type === 'include' && rules[rule].publisher) {
                    //Check if requested partners have already been included or not
                    currentPartners.push(rules[rule].publisher)
                } else if (
                    rules.length === 1 &&
                    rules[rule].type === 'include' &&
                    rules[rule].all === true
                ) {
                    //Check if default rule is repeated or not.
                    //Length will be 1 if it is
                    isDefaultRule = true
                }
            }

        //Get if partners currently included and partners in the request are same
        let partnersUnchanged =
            breakoutPartners.length === currentPartners.length &&
            breakoutPartners.every(element => currentPartners.includes(element))

        //No action needed if
        //my partners haven't changed from current subscription
        //If the base rule is being repeated
        //If the default rule is being repeated
        if (partnersUnchanged && !isDefaultRule) return

        rules = rules = prepareRules(breakoutPartners)

        return axiosInstance(rules, roomSid, participantSid)
            .then(response => {
                logger.info(
                    `Subscribed to audio of students of unlocked room by teacher. ${JSON.stringify(
                        response.data
                    )}`
                )
            })
            .catch(error => {
                logger.error(
                    `Failed to subscribe to audio of students of unlocked room by teacher. ${JSON.stringify(
                        error
                    )}`
                )
            })
    })
}

export const unsubscribeFromStudents = (roomSid, participantSid) => {
    let currentRules = axiosInstance(null, roomSid, participantSid)
    currentRules.then(function(response) {
        let rules
        let isDefaultRule = false
        let isBaseRule = false
        if (response.data) rules = response.data.rules
        if (rules)
            for (let rule in rules) {
                if (
                    rules.length === 1 &&
                    rules[rule].type === 'include' &&
                    rules[rule].kind === trackKinds.video
                ) {
                    //Check if the base rule is repeated or not
                    //Length will be 1 if it is
                    //Length will be greater if the current Twilio rules contains participant includes as well
                    isBaseRule = true
                } else if (
                    rules.length === 1 &&
                    rules[rule].type === 'include' &&
                    rules[rule].all === true
                ) {
                    //Check if default rule is repeated or not.
                    //Length will be 1 if it is
                    isDefaultRule = true
                }
            }

        //No action needed if
        //If the base rule is being repeated
        //If the default rule is being repeated
        if (isBaseRule || isDefaultRule) return

        rules = rules = prepareRules([])

        return axiosInstance(rules, roomSid, participantSid)
            .then(response => {
                logger.info(
                    `Unsubscribed from audio of students of unlocked room by teacher. ${JSON.stringify(
                        response.data
                    )}`
                )
            })
            .catch(error => {
                logger.error(
                    `Failed to unubscribe from audio of students of unlocked room by teacher. ${JSON.stringify(
                        error
                    )}`
                )
            })
    })
}

export const subscribeToNewStudent = (
    breakoutPartners,
    roomSid,
    participantSid
) => {
    let currentRules = axiosInstance(null, roomSid, participantSid)
    currentRules.then(function(response) {
        let rules
        let currentPartners = []
        let isDefaultRule = false
        if (response.data) rules = response.data.rules
        if (rules)
            for (let rule in rules) {
                if (rules[rule].type === 'include' && rules[rule].publisher) {
                    //Check if requested partners have already been included or not
                    currentPartners.push(rules[rule].publisher)
                } else if (
                    rules.length === 1 &&
                    rules[rule].type === 'include' &&
                    rules[rule].all === true
                ) {
                    //Check if default rule is repeated or not.
                    //Length will be 1 if it is
                    isDefaultRule = true
                }
            }

        //Get if partners currently included and partners in the request are same
        let partnersUnchanged =
            breakoutPartners.length === currentPartners.length &&
            breakoutPartners.every(element => currentPartners.includes(element))

        //No action needed if
        //my partners haven't changed from current subscription
        //If the base rule is being repeated
        //If the default rule is being repeated
        if (partnersUnchanged && !isDefaultRule) return

        rules = rules = prepareRules(breakoutPartners)

        return axiosInstance(rules, roomSid, participantSid)
            .then(response => {
                logger.info(
                    `Subscribed to new student by teacher in main room. ${JSON.stringify(
                        response.data
                    )}`
                )
            })
            .catch(error => {
                logger.error(
                    `Failed to subscribe to new student by teacher in main room. ${JSON.stringify(
                        error
                    )}`
                )
            })
    })
}

export const subscribeToAllMedia = (roomSid, participantSid) => {
    let rules = qs.stringify({
        Rules: '[{"type": "include", "all": true}]',
    })

    axiosInstance(rules, roomSid, participantSid)
        .then(response => {
            logger.info(
                `[TEACHER] Subscribed to all media. ${JSON.stringify(
                    response.data
                )}`
            )
        })
        .catch(error => {
            logger.error(
                `[TEACHER] Failed to subscribe to all media. ${JSON.stringify(
                    error
                )}`
            )
        })
}

export const unsubscribeBreakoutAll = (roomSid, participantSid) => {
    let rules = qs.stringify({
        Rules: '[{"type": "include", "kind": "video"}]',
    })

    axiosInstance(rules, roomSid, participantSid)
        .then(response => {
            logger.info(
                `[TEACHER] Unsubscribed from all audio. ${JSON.stringify(
                    response.data
                )}`
            )
        })
        .catch(error => {
            logger.error(
                `[TEACHER] Failed to unsubscribe from all audio. ${JSON.stringify(
                    error
                )}`
            )
        })
}

const getBreakoutPartners = (
    breakoutParticipants,
    teacher_rooms,
    participants,
    room,
    isTeacher,
    getIdentity
) => {
    let breakoutPartners = []
    for (let i = 0; i < breakoutParticipants.length; i++) {
        let objValues = breakoutParticipants[i].students
        if (objValues.includes(room.localParticipant.identity))
            breakoutPartners = objValues.filter(
                p => p !== room.localParticipant.identity
            )
    }
    let teacherId
    if (!isTeacher && teacher_rooms?.length) {
        let studentsObj = breakoutParticipants.find(
            rm => rm.name === teacher_rooms[0]
        )
        if (studentsObj.students.includes(room.localParticipant.identity)) {
            teacherId = participants.find(
                t => getIdentity(t.identity).isTeacher === true
            )
        }
        teacherId && breakoutPartners.push(teacherId.identity)
    } else if (isTeacher && teacher_rooms?.length) {
        let studentsObj = breakoutParticipants.find(
            rm => rm.name === teacher_rooms[0]
        )
        breakoutPartners = studentsObj.students
    }

    return breakoutPartners
}

export const setSubscriptions = (
    breakoutParticipants,
    teacher_rooms,
    participants,
    room,
    isTeacher,
    getIdentity,
    setMyGroup
) => {
    const isTeacherRoomUnavailable =
        teacher_rooms?.length <= 0 || !teacher_rooms

    if (isTeacher && isTeacherRoomUnavailable) {
        unsubscribeBreakoutAll(room.sid, room.localParticipant.sid)
        return
    }

    let breakoutPartners = getBreakoutPartners(
        breakoutParticipants,
        teacher_rooms,
        participants,
        room,
        isTeacher,
        getIdentity,
        setMyGroup
    )

    setMyGroup(breakoutPartners)

    subscribeToMyPartners(
        breakoutPartners,
        room.sid,
        room.localParticipant.sid,
        isTeacher
    )
}

const videoSubscriptionRules = [
    { type: 'include', all: true },
    { type: 'exclude', kind: trackKinds.video },
    { type: 'include', track: 'screen' }, // for screen share
]

export const unsubscribeFromAllParticipantsVideo = async (
    roomSid,
    participantSid
) => {
    const rules = qs.stringify({
        Rules: JSON.stringify(videoSubscriptionRules),
    })

    try {
        await axiosInstance(rules, roomSid, participantSid)
    } catch (error) {
        logger.error(`error in unsubscribeFromAllParticipantsVideo :- ${error}`)
    }
}

export const unsubscribeFromAllParticipantsVideoExceptTeacher = async (
    roomSid,
    participantSid,
    teacherSid
) => {
    const rules = qs.stringify({
        Rules: JSON.stringify([
            ...videoSubscriptionRules,
            { type: 'include', kind: trackKinds.video, publisher: teacherSid },
        ]),
    })

    try {
        await axiosInstance(rules, roomSid, participantSid)
    } catch (error) {
        logger.error(
            `error in unsubscribeFromAllParticipantsVideoExceptTeacher :- ${error}`
        )
    }
}

export const subscribeToAllParticipantsTracks = async (
    roomSid,
    participantSid
) => {
    const rules = qs.stringify({
        Rules: JSON.stringify([{ type: 'include', all: true }]),
    })

    // todo: if ghost do not subscribe

    try {
        await axiosInstance(rules, roomSid, participantSid)
    } catch (error) {
        logger.error(`error in subscribeToAllParticipantsTracks :- ${error}`)
    }
}

export const switchToBandwidthSaverMode = async identity => {
    const roomSid = getRoomSid()
    const participantSid = getParticipantSidByIdentity(identity)

    // const userType = isTeacher(identity) ? userTypes.TEACHER : userTypes.STUDENT
    // const teacherSid = getTeacherSid(userType === userTypes.TEACHER)

    // try {
    //     if (userType === userTypes.STUDENT && teacherSid) {
    //         await unsubscribeFromAllParticipantsVideoExceptTeacher(
    //             roomSid,
    //             participantSid,
    //             teacherSid
    //         )
    //     } else {
    //         await unsubscribeFromAllParticipantsVideo(roomSid, participantSid)
    //     }
    // } catch (error) {
    //     logger.error(`error in switchToBandwidthSaverMode :- ${error}`)
    // }

    // const userType = isTeacher(identity) ? userTypes.TEACHER : userTypes.STUDENT
    // const teacherSid = getTeacherSid(userType === userTypes.TEACHER)

    try {
        await unsubscribeFromAllParticipantsVideo(roomSid, participantSid)
    } catch (error) {
        logger.error(`error in switchToBandwidthSaverMode :- ${error}`)
    }
}

export const switchToNormalMode = async identity => {
    const roomSid = getRoomSid()
    const participantSid = getParticipantSidByIdentity(identity)

    try {
        if (isDesktop) {
            await subscribeToAllParticipantsTracks(roomSid, participantSid)
        } else {
            const userType = isTeacher(identity)
                ? userTypes.TEACHER
                : userTypes.STUDENT
            const teacherSid = getTeacherSid(userType === userTypes.TEACHER)

            if (teacherSid) {
                await unsubscribeFromAllParticipantsVideoExceptTeacher(
                    roomSid,
                    participantSid,
                    teacherSid
                )
            }
        }
    } catch (error) {
        logger.error(`error in switchToNormalMode :- ${error}`)
    }
}
